;(function () {
  angular
    .module('contrast.tsv.onboard')
    .controller('TsvModalCtrl', tsvModalCtrl)

  function tsvModalCtrl(
    $scope,
    $uibModalInstance,
    $uibModal,
    $document,
    $location,
    tsvApiConfig,
    ErrorService,
    UserService,
    isTsvMandatory
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        step: 0,
        isTsvMandatory: isTsvMandatory
      }
    })

    angular.extend($scope, {
      next: next,
      back: back,
      getStarted: getStarted,
      cancel: cancel,
      exitLearnMore: exitLearnMore
    })

    function next() {
      $scope.model.step++
    }

    function back() {
      $scope.model.step--
    }

    function getStarted() {
      setOnboardShown().then(function () {
        $uibModal.open({
          templateUrl: 'views/tsv/setupwizard.html',
          controller: 'TsvModalWizardCtrl',
          appendTo: $document.find('aside'),
          windowClass: 'tsv-setup-dialog',
          backdrop: false,
          keyboard: false,
          resolve: {
            isTsvMandatory: isTsvMandatory
          }
        })

        $uibModalInstance.dismiss('cancel')
      })
    }

    function cancel() {
      if (!isTsvMandatory) {
        setOnboardShown().then(function () {
          $location.path(UserService.buildUrl('/dashboard'), true)
          $uibModalInstance.dismiss('cancel')
        })
      }
    }

    function setOnboardShown() {
      return tsvApiConfig
        .updateOnboardSettings()
        .then(function () {}, ErrorService.processError)
    }

    function exitLearnMore() {
      if (isTsvMandatory) {
        getStarted()
      } else {
        $scope.model.step = 0
      }
    }
  }
})()
